var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.75 7.5a.25.25 0 1 0-.5 0 .25.25 0 0 0 .5 0m1.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.25 11.172V6A3.75 3.75 0 0 1 6 2.25h5.172c.73 0 1.429.29 1.944.806l7.71 7.71a3.16 3.16 0 0 1 0 4.468l-5.592 5.592a3.16 3.16 0 0 1-4.468 0l-7.71-7.71a2.75 2.75 0 0 1-.806-1.944m1.5 0 .006.123c.028.286.155.556.36.76l7.71 7.71a1.66 1.66 0 0 0 2.348 0l5.592-5.591a1.66 1.66 0 0 0 0-2.348l-7.71-7.71a1.25 1.25 0 0 0-.761-.36l-.123-.006H6A2.25 2.25 0 0 0 3.75 6z"
  })));
};
export default SvgTag;